import { ResponseError } from '../../errors';
import { IHeaderData } from '../../headerData';
import { prepareHeaderData } from '../../mappers/prepareHeaderData';
import { fetchGetHeader, TGetHeaderResponse } from '../../repositories/header/v1/get-header';
import { IApplicationContext } from '../../types/applicationContext';

interface IGetHeaderDataParameters {
  /** ID региона пользователя **/
  locationId?: number | null;
  /** Поддомен **/
  subdomain?: string | null;
}

export async function getHeaderData(
  context: IApplicationContext,
  parameters: IGetHeaderDataParameters = {},
): Promise<IHeaderData> {
  const { httpApi } = context;

  const headerData: TGetHeaderResponse = await fetchGetHeader({
    httpApi,
    parameters: {
      ...parameters,
    },
  });

  if (headerData.statusCode !== 200) {
    throw new ResponseError({
      domain: 'getHeaderData',
      message: headerData.response.message,
      details: {
        error: headerData.response.errors,
      },
    });
  }

  return prepareHeaderData(context, headerData.response);
}
